// extracted by mini-css-extract-plugin
export default {"buttons":"AdminNavbar_buttons__S6jcx","adnavbar":"AdminNavbar_adnavbar__L-g1U","nav":"AdminNavbar_nav__Ktzhn","navres":"AdminNavbar_navres__ChqFH","logo":"AdminNavbar_logo__uISY-"};